<template>
  <a-drawer
    class="changelog__drawer"
    :visible="visible"
    :width="650"
    title="更新日志"
    placement="right"
    @close="handleClose"
    :mask-closable="true"
    destroy-on-close>
    <div class="changelog__content">
      <!-- 提示信息 -->
      <a-alert type="warning" class="changelog__alert">
        <template #description>
          <a-space>
            <a-icon style="color: #faad14" type="notification" />
            <span style="color: #000000; margin-left: 8px"
              >产品功能相关问题请咨询项目经理</span
            >
          </a-space>
        </template>
      </a-alert>

      <!-- 更新日志内容 -->
      <div class="changelog__log">
        <div class="changelog__log__header">
          <h4 class="changelog__log__title">更新日志内容</h4>
        </div>
        <div class="changelog__log__content" v-html="logContent" />
      </div>
    </div>
  </a-drawer>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: false,
    },
    logContent: {
      type: String,
      default: '',
    },
  },
  methods: {
    handleClose() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="less" scoped>
.changelog__drawer {
  .changelog__alert {
    margin-bottom: 24px;
  }
  .changelog__log {
    position: relative;
    padding-left: 20px;

    &::before {
      content: '';
      position: absolute;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background: #44c7d8;
      border: 3px solid var(--main-bg);
      box-shadow: 0 0 0 2px var(--main-color);
      left: 0px;
      top: 8px;
    }

    &::after {
      content: '';
      position: absolute;
      left: 5px;
      top: 20px;
      bottom: 0;
      width: 2px;
      background-color: #fafafa;
    }

    &__header {
      margin-bottom: 16px;
    }

    &__title {
      color: var(--text-color);
      font-size: 16px;
      font-weight: 500;
      margin-bottom: 16px;
      margin-top: 0;
    }

    &__content {
      padding: 16px 20px;
      background: #fafafa;
      color: var(--text-color);
      line-height: 1.6;

      // 富文本编辑器内容样式兼容
      ::v-deep {
        // 标题样式
        h1,
        h2,
        h3,
        h4,
        h5,
        h6 {
          color: var(--text-color);
          margin-top: 1em;
          margin-bottom: 0.5em;
          font-weight: 500;
        }

        // 段落样式
        p {
          margin-bottom: 1em;
          color: var(--text-color);
        }

        // 列表样式
        ul,
        ol {
          margin-bottom: 1em;
          padding-left: 2em;

          li {
            margin-bottom: 0.5em;
            color: var(--text-color);
          }
        }

        // 图片样式 - 参考上传图片样式
        img {
          max-width: 100%;
          height: auto;
          border-radius: 4px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
          margin: 8px 0;
          display: block;
        }

        // 代码块样式
        pre {
          background-color: var(--module-bg);
          border: 1px solid var(--border-color-base);
          border-radius: 4px;
          padding: 12px;
          overflow-x: auto;
          margin-bottom: 1em;

          code {
            color: var(--text-color);
            background: transparent;
          }
        }

        // 行内代码样式
        code {
          background-color: var(--module-bg);
          color: var(--text-color);
          padding: 2px 4px;
          border-radius: 2px;
          font-size: 0.9em;
        }

        // 引用样式
        blockquote {
          border-left: 4px solid var(--main-color);
          padding-left: 16px;
          margin: 16px 0;
          color: var(--text-color-secondary);
          font-style: italic;
        }

        // 表格样式
        table {
          width: 100%;
          border-collapse: collapse;
          margin-bottom: 1em;

          th,
          td {
            border: 1px solid var(--border-color-base);
            padding: 8px 12px;
            text-align: left;
            color: var(--text-color);
          }

          th {
            background-color: var(--module-bg);
            font-weight: 500;
          }
        }

        // 链接样式
        a {
          color: var(--main-color);
          text-decoration: none;

          &:hover {
            text-decoration: underline;
          }
        }

        // 分割线样式
        hr {
          border: none;
          border-top: 1px solid var(--border-color-base);
          margin: 24px 0;
        }

        // 强调文本样式
        strong,
        b {
          font-weight: 600;
          color: var(--text-color);
        }

        em,
        i {
          font-style: italic;
          color: var(--text-color);
        }
      }
    }
  }
}
</style>
